module.exports = __webpack_public_path__ + "media/images/vector/vector4-68a56b542c0f681a7963a7c05978ae98.png";